module.exports = __webpack_public_path__ + "img/samsara-table.dbba11e7.svg";